import axiosInstance from '../../core/axiosConfig';
export class LocationService {
  async getLocationTypes(language: string = 'ENG') {
    const response = await axiosInstance.get('/location/type/list', { params: { language } });
    return response.data;
  }

  async getLocations(language: string = 'ENG') {
    const response = await axiosInstance.get('/location/list', { params: { language } });
    return response.data;
  }
}
